/**
 * 📸 Kamera-Station Client — Relay vom Foto-Handy zum Tablet
 *
 * Das Foto-Handy nimmt auf, analysiert (mlService.analyzeImage) und schickt das
 * Ergebnis hierüber an die anderen Geräte des Users. Der Server pusht es per SSE
 * (Event „station:capture") ans Tablet, das daraus den Erfassen-Entwurf befüllt.
 */
import { api } from './apiService';

/**
 * Relay eines aufgenommenen, analysierten Fotos an die anderen Geräte.
 * @param {{result?: object, fields?: object, preview?: string}} payload
 *   result  = Rückgabe von analyzeImage (ocrResult/metadata/imageId) für die Felder
 *   preview = base64-JPEG (kleiner Ausschnitt) für die Sofort-Anzeige am Tablet
 * @returns {Promise<{ok: boolean, devices: number}>}
 */
export async function relayCapture(payload) {
  return api.post('/station/capture', payload);
}

/**
 * Verbindungstest: liefert, wie viele Geräte des Users aktuell lauschen
 * (z. B. das Tablet). devices >= 1 → das Tablet ist erreichbar.
 * @returns {Promise<{ok: boolean, devices: number}>}
 */
export async function stationPing() {
  return api.get('/station/ping');
}

/**
 * Steuer-Signal zwischen Tablet und Handy (Modus-Sync, Zoom/Rahmen, Vorschau).
 * @param {string} event  z. B. 'station:mode' | 'station:config' | 'station:request-preview' | 'station:preview'
 * @param {object} [data]
 */
export async function relaySignal(event, data) {
  return api.post('/station/signal', { event, data: data || {} });
}

/**
 * 🏷️ Bundle-Kennung dieses Geräts (Dateiname des geladenen main.<hash>.js).
 * Für die Fern-Diagnose „welcher Code läuft da wirklich?" — nachdem wir mehrfach
 * an veralteten Bundles gescheitert sind, ohne es zu sehen (nginx loggt /static nicht).
 */
export function bundleId() {
  try {
    const s = document.querySelector('script[src*="/static/js/main."]');
    return s ? s.src.split('/').pop() : '?';
  } catch { return '?'; }
}
